import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

import Legislacao from '../Legislacao';

//Context
import { useAuth } from '../../../context/auth';

const getManuais = (caminhoVirtual) => [
    {
        title: "RCC- Manual Cadastro Transportador",
        link: caminhoVirtual + "RCCManualCadastroTransportador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Gerador",
        link: caminhoVirtual + "RCCManualCadastroGerador.pdf"
    },
    {
        title: "RCC - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RCCManualCadastroDestinoFinal.pdf"
    },
    {
        title: "RSS - ManualCadastro Gerador",
        link: caminhoVirtual + "RSSManualCadastroGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Transportador",
        link: caminhoVirtual + "RGGManualCadastroTransportador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Grande Gerador",
        link: caminhoVirtual + "RGGManualCadastroGrandeGerador.pdf"
    },
    {
        title: "RGG - Manual Cadastro Destino Final",
        link: caminhoVirtual + "RGGManualCadastroDestinoFinal.pdf"
    },
    {
        title: "Manual Taxa Fislurb",
        link: caminhoVirtual + "ManualTaxaFislurb.pdf"
    },
];

export default function Duvidas() {
    const { setupSistema } = useAuth();

    const [informacoes, setInformacoes] = useState([
        {
            title: "Qual o custo para o cadastro?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Para o estabelecimento grande gerador, é devido o pagamento de preço público de R$ 286,50 (atualização anual dos valores por decreto) e tem validade de um ano.
                    </p>
                    <p>
                        Os tratamentos são diferenciados para o Grande e para o Pequeno Gerador.
                    </p>
                    <p>
                        Para o Pequeno Gerador, não é cobrado taxa ou o Preço Público e nem a obrigatoriedade de realização de cadastro,  e não há previsão legal de multa.
                    </p>
                    <p>
                        Para o Grande Gerador as obrigações estão discriminadas na legislação vigente Lei 13.478/02 e decreto 58.701/19 e estes não podem utilizar da coleta publica
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual a penalidade para quem não se cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Quem não estiver cadastrado e for enquadrado pela Prefeitura após fiscalização como um grande gerador de lixo
                        – acima de 200 litros por dia – estará sujeito a multa de R$ 1.639,60 (valores reajustáveis)
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Quem precisa se cadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Grandes Geradores - Estabelecimentos com geração de resíduos acima de 200 litros por dia.
                    </p>
                    <p>
                        Condomínio Não Residencial ou Misto - cuja soma dos resíduos sólidos totalize o volume médio diário igual ou superior a 1.000 (mil) litros; privada para a remoção desses resíduos.
                    </p>
                    <p>
                        Transportadores de Resíduos – Com SEDE ou FILIAL aberta no município de São Paulo.
                    </p>
                    <p>
                        Áreas de Transbordo e Destino Final – Áreas licenciadas para a recepção de resíduos Classe II A (Resíduos Orgânicos)
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Como saber se sou um grande gerador?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        De acordo com a LEI 13.478/02 e suas alterações e os Decretos regulamentadores, estando estes em consonância com o PGIRS - Plano de Gestão Integrada de Resíduos Sólidos, todos os estabelecimentos com geração de resíduos acima de 200 litros por dia.
                    </p>
                    <p>
                        Os condomínios de edifícios não-residenciais ou de uso misto cuja soma dos resíduos sólidos, caracterizados como resíduos da Classe 2 pela NBR 10.004, da ABNT, gerados pelas unidades autônomas que os compõem, totalize o volume médio diário igual ou superior a 1.000 (mil) litros; são considerados Grandes Geradores e devem contratar coleta privada para a remoção desses resíduos.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Sou um transportador com sede em outro município, mas transporto resíduos na capital. Devo me cadastrar no sistema CTR-E RGG?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Para os transportadores é obrigatório que os mesmos tenham SEDE ou FILIAL aberta no município de São Paulo bem como o Ato de registro de funcionamento emitido pela Subprefeitura local e demais documentos exigidos no momento do cadastro sendo essa uma condição indispensável para poder prestar os serviços na capital.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual o custo de inscrição no CTR-E RGG?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Não há custo para o uso do sistema CTR-E RGG. Porém há cobrança do preço público para a realização do cadastro na SP REGULA que já era aplicado no processo de cadastramento físico. Por exemplo, os grandes geradores deverão pagar uma taxa anual estabelecida pelo Decreto de Preços Público atualizada anualmente de: R$ 286,50 e para os Transportadores o valor de R$ 146,90 e para os Veículos R$58,20.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Qual é a validade do cadastro pago para a SP REGULA?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        A validade do cadastro na SP REGULA é de 1 ano, para todos os entes envolvidos na cadeia de resíduos sólidos. Após esse período é preciso realizar o renovação cadastral no sistema CTR-E RGG.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Minha empresa gera resíduos, mas ainda não tenho uma empresa de transportes para enviá-los para um destino autorizado. Como posso contratar este serviço?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Você pode buscar a lista de transportadores licenciados na SP REGULA no site <a href="https://www.prefeitura.sp.gov.br/cidade/secretarias/spregula/" target='_blank'>www.spregula.sp.gov.br</a>.
                    </p>
                </div>
            ),
            collapse: false
        },
        {
            title: "Como ficam as emissões de CTR, agora com a integração com SIGOR (Estadual) e o SINIR (Federal)?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Conforme acordado entre os órgãos das esferas Municipal, Estadual e Federal, os Geradores situados nos municípios que já possuem o sistema CTR-E, devem  utilizar deste sistema para a emissão dos seus CTRs. Os sistemas estão sendo integrados e todas as emissões serão compartilhadas entre os órgãos de fiscalização e controle. Portanto, todos devem continuar a emitir seus CTRs. A Transferência de dados é de responsabilidade da SP REGULA, CETESB e SINIR.
                    </p>
                </div>
            ),
            collapse: false
        },
    ]);

    const [informacoesRecadastramentro, setInformacoesRecadastramentro] = useState([
        {
            title: "Quem precisa se recadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Todos os Grandes Geradores, Transportadoras e Destinos Finais. Em resumo, todas as empresas
                        que participam da cadeia de geração, coleta e destinação dos resíduos de Grandes Geradores
                        do município de São Paulo, e que já possuem cadastro ativo.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Será necessário pagar o preço público novamente?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Não! Se a sua empresa possui atualmente um cadastro ativo, não será gerada nenhuma cobrança adicional.
                    </p>
                    <p>
                        Porém será necessário informar a vigência do cadastro atual e enviar o comprovante de pagamento para análise.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "A validade do meu cadastro atual será mantida?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        A vigência do cadastro ativo será mantida, mas será necessário que seja preenchido corretamente a data de vencimento e submetida o comprovante de pagamento.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Eu sou um Grande Gerador, como farei para vincular meu contrato com a minha Transportadora?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        O cadastro é efetuado em algumas etapas e o vínculo do contrato com a empresa de transporte será solicitado ao Grande Gerador na etapa de Locais de Coleta.
                    </p>
                    <p>
                        Para maiores dúvidas, consulte o manual de recadastramento de Grandes Geradores <a href={`${setupSistema?.caminhoVirtual + "ManualRecadastramentoGrandeGerador_RGG.pdf"}`} target="_blank" className='text-danger'>clicando aqui.</a>
                    </p>
                    <p>
                        <strong className='text-danger'>Importante:</strong> Nessa etapa, o Grande Gerador terá que selecionar o seu Transportador em uma lista que será exibida para ele. Só serão exibidos os Transportadores que realizaram o Recadastramento,
                        caso seu Transportador não retorne é porque ele ainda não se recadastrou.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Os Pequenos Geradores precisam se recadastrar?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Não!
                    </p>
                    <p>
                        O Recadastramento será apenas para os Grandes Geradores Privados, Condomínio Misto, Público (Estadual/Federal) e Público Municipal, além dos Transportadores e Destinos Finais.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Será necessário imprimir as etiquetas de QR Code novamente?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        Sim, será necessário a impressão de uma nova etiqueta de identificação em cada estabelecimento.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Quando posso começar a utilizar somente o novo sistema?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        O novo sistema irá trabalhar em paralelo com o antigo CTRE (ctre.com.br) durante 30 dias, com inicio no dia 20/12/2023, quando será liberado o recadastramento dos grandes geradores, até o dia 20/01/2024.
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
        {
            title: "Sou Transportador, como cadastro meus veículos?",
            texto: () => (
                <div className='mt-2'>
                    <p>
                        O cadastro dos veículos será feito em 2 etapas.
                    </p>
                    <p>
                        Durante o cadastro do Transportador é obrigatório o cadastramento de ao menos 1 veículo. Após esta etapa, poderá adicionado todos os outros.
                    </p>
                    <p>
                        Todos os itens com cadastro atual ativo, incluindo veículos, não terão cobrança.
                    </p>
                    <p>
                        Para maiores dúvidas, consulte o manual de recadastramento de Transportadores <a href={`${setupSistema?.caminhoVirtual + "ManualRecadastramentoTransportador_RGG.pdf"}`} target="_blank" className='text-danger'>clicando aqui.</a>
                    </p>
                </div>
            ),
            collapse: false,
            link: null
        },
    ]);

    //State para mostrar legislação
    const [mostrarLegislacao, setMostrarLegislacao] = useState(false);
    const [mostrarManual, setMostrarManual] = useState(false);

    const handleMostrarTexto = (index) => {
        setInformacoes(prevState => {
            const _mensagens = [...prevState];
            _mensagens[index] = { ..._mensagens[index], collapse: !_mensagens[index].collapse };
            return _mensagens;
        });
    }

    const handleMostrarRecadastramentoTexto = (index) => {
        setInformacoesRecadastramentro(prevState => {
            const _mensagens = [...prevState];
            _mensagens[index] = { ..._mensagens[index], collapse: !_mensagens[index].collapse };
            return _mensagens;
        });
    }

    return <div className="content" style={{ marginTop: "40px" }}>
        {/* cabeçalho */}
        <div className={"d-flex justify-content-between align-items-center mb-0 pb-0"} style={{ color: "#666" }}>
            <div lg={11}>
                <h5 className='mb-0' style={{ fontWeight: "bold", marginTop: "10px" }}>Dúvidas sobre coleta e destinação de resíduos?</h5>
            </div>
            <div lg={1}>
                <div
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    style={{
                        width: "50px",
                        height: "50px",
                        border: "3px solid #666",
                        background: "transparent"
                    }}
                >
                    <div style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#666"
                    }}>
                        ?
                    </div>
                </div>
            </div>
        </div>
        <div className="mt-0">
            <hr style={{ border: "2px solid #666" }} />
        </div>

        {/* Topicos */}
        <div className='row' style={{ color: "#666" }}>

        <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Manuais</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>

                <div
                    className='mb-2 rounded p-2 d-flex justify-content-between align-items-center'
                    style={{ background: "#b6b3b3" }}
                    type={"button"}
                    onClick={() => setMostrarManual(!mostrarManual)}
                >
                    <h6 className='mb-0 text-white' >Mostrar todos os manuais</h6>
                    <i className="fas fa-cloud-download-alt text-white"></i>
                </div>
                {mostrarManual &&
                    getManuais(setupSistema?.caminhoVirtual ?? '').map((value, index) => {
                        return <div className='mt-2'>
                            <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(value.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{value.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>

            <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Grandes Geradores de Resíduos Sólidos</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>
                {/* Conteudo */}
                {informacoes.map((value, index) => {
                    if(value.link == null)
                    {
                        const Component = value.texto;
                        return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3" }}>
                            <div className='d-flex align-items-center justify-content-between w-100'
                                type="button"
                                onClick={() => handleMostrarTexto(index)}
                            >
                                <h6 className='mb-0' style={{ fontWeight: informacoes[index].collapse ? "bold" : "normal" }}>{value.title}</h6>
                                {informacoes[index].collapse ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                            </div>
                            <Collapse isOpen={value.collapse} className="mt-2">
                                <Component />
                            </Collapse>
                        </div>
                    } else {
                        return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(value.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{value.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                    }
                })}
                <div
                    className='mb-2 rounded p-2 d-flex justify-content-between align-items-center'
                    style={{ background: "#b6b3b3" }}
                    type={"button"}
                >
                    <h6 className='mb-0 text-white' >Recadastramento de Grandes Geradores</h6>
                </div>
                    {informacoesRecadastramentro.map((value, index) => {
                        if (value.link == null) {
                            const Component = value.texto;
                            return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => handleMostrarRecadastramentoTexto(index)}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: informacoesRecadastramentro[index].collapse ? "bold" : "normal" }}>{value.title}</h6>
                                    {informacoesRecadastramentro[index].collapse ? <i className="fas fa-angle-up"></i> : <i className="fas fa-angle-down"></i>}
                                </div>
                                <Collapse isOpen={value.collapse} className="mt-2">
                                    <Component />
                                </Collapse>
                            </div>
                        } else {
                            return <div key={index} className=' mb-2 rounded p-2' style={{ border: "2px solid #b6b3b3", background: "rgb(226, 218, 218)" }}>
                                <div className='d-flex align-items-center justify-content-between w-100'
                                    type="button"
                                    onClick={() => window.open(value.link, "_blank")}
                                >
                                    <h6 className='mb-0' style={{ fontWeight: "normal" }}>{value.title}</h6>
                                    <i className="fas fa-file-alt"></i>
                                </div>
                            </div>
                        }
                    })}
            </div>

            <div className="col-sm-12 my-2">
                <div className='d-flex justify-content-between align-items-center'>
                    <h6 className='fw-bold'>Legislações</h6>
                    <div style={{ border: "2px solid #666", width: "30px", marginTop: "4px" }}></div>
                </div>

                <div
                    className='mb-2 rounded p-2 d-flex justify-content-between align-items-center'
                    style={{ background: "#b6b3b3" }}
                    type={"button"}
                    onClick={() => setMostrarLegislacao(!mostrarLegislacao)}
                >
                    <h6 className='mb-0 text-white' >Mostrar todas as legislações</h6>
                    <i className="fas fa-cloud-download-alt text-white"></i>
                </div>
                {mostrarLegislacao &&
                    <Legislacao />
                }
            </div>

        </div>

    </div>;

}